import React from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'

import { Tabs } from './Tabs'
import { UserMenu } from '../UserMenu'
import { BotActions } from '../BotActions'
import { UsersPanel } from '../UsersPanel'

interface Props {
  hideDesignerSpecific?: boolean
}

export const TopHeaderTabs: React.FC<Props> = ({ hideDesignerSpecific }) => {
  const { pathname } = useLocation()
  if (pathname === '/login') {
    return null
  }

  return (
    <>
      {!hideDesignerSpecific && <BotActions />}
      <Push />
      <Spacer>{pathname !== '/users' && <Tabs />}</Spacer>
      <UsersPanel />
      <UserMenu />
    </>
  )
}

export const Push = styled.div`
  margin-left: auto;
`

const Spacer = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
`
